import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Pipe({
  name: 'fullDate'
})
export class FullDatePipe implements PipeTransform {

  constructor(private translate: TranslateService){}

  transform(date: moment.Moment, withTime: boolean = true, withoutSeconds: boolean = false): string {
    if (!date || !date.isValid()) {
      return this.translate.instant('pipe.fulldate.error');
    }

    if (withTime) {
      if (withoutSeconds) {
        return date.format('YYYY-MM-DD HH:mm')
      }
      return date.format('YYYY-MM-DD HH:mm:ss');
    }

    return date.format('YYYY-MM-DD');
  }

}
